export class FileDirectUploadModel {
	upload_url: string;
	upload_location: string;
	upload_filename: string;
	bucket: string;
	final_location: string;
	temporary_location: string;
	file_upload_key: string;
}

export interface FileDirectUploadArgument {
	file_name: string;
	file_size: number;
	upload_type: 'enrollment' | 'transcript';
}
